import { render, staticRenderFns } from "./LiveHubs.vue?vue&type=template&id=2a42603f&scoped=true&"
import script from "./LiveHubs.vue?vue&type=script&lang=js&"
export * from "./LiveHubs.vue?vue&type=script&lang=js&"
import style0 from "./LiveHubs.vue?vue&type=style&index=0&id=2a42603f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42603f",
  null
  
)

export default component.exports